import { Component, Input } from '@angular/core';
import { PMFormatShareholder } from '../../../../data/interfaces/circle-credit.interface';

@Component({
  selector: 'app-circle-credit-shareholder-card',
  templateUrl: './circle-credit-shareholder-card.component.html',
  styleUrls: ['./circle-credit-shareholder-card.component.scss']
})
export class CircleCreditShareholderCardComponent {
  @Input() data: PMFormatShareholder | null = null;

  get hasData(): boolean {
    if (!this.data) return false;
    return !!(this.data.companyName || this.data.rfc || this.data.firstName);
  }

  get completionPercentage(): number {
    if (!this.data) return 0;
    
    const allFields = [
      'rfc', 'companyName', 'firstName', 'percentage', 'address1', 
      'city', 'state', 'phone', 'clientType'
    ];
    const filledFields = allFields.filter(field => this.data![field as keyof PMFormatShareholder]);
    return Math.round((filledFields.length / allFields.length) * 100);
  }

  get statusClass(): string {
    if (!this.hasData) return 'status-empty';
    const percentage = this.completionPercentage;
    if (percentage < 30) return 'status-incomplete';
    if (percentage < 70) return 'status-partial';
    return 'status-complete';
  }

  get shareholderName(): string {
    if (!this.data) return 'No especificado';
    
    if (this.data.companyName) {
      return this.data.companyName;
    }
    
    const parts = [
      this.data.firstName,
      this.data.middleName,
      this.data.lastNameFatherShareholder,
      this.data.lastNameMotherShareholder
    ].filter(part => part && part.trim());
    
    return parts.join(' ') || 'No especificado';
  }

  get fullAddress(): string {
    if (!this.data) return 'No especificado';
    
    const parts = [
      this.data.address1,
      this.data.address2,
      this.data.neighborhood,
      this.data.municipality,
      this.data.city,
      this.data.state,
      this.data.postalCode
    ].filter(part => part && part.trim());
    
    return parts.join(', ') || 'No especificado';
  }

  formatPhone(phone: string | undefined): string {
    if (!phone) return 'No especificado';
    
    // Formato básico para teléfonos mexicanos
    const cleaned = phone.replace(/\D/g, '');
    if (cleaned.length === 10) {
      return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
    }
    return phone;
  }

  get shareholderType(): 'company' | 'individual' {
    return this.data?.companyName ? 'company' : 'individual';
  }

  get percentageDisplay(): string {
    if (!this.data?.percentage) return 'No especificado';
    return `${this.data.percentage}%`;
  }

  get percentageStatus(): 'major' | 'significant' | 'minor' {
    if (!this.data?.percentage) return 'minor';
    
    if (this.data.percentage >= 50) return 'major';
    if (this.data.percentage >= 25) return 'significant';
    return 'minor';
  }
}
